import React from 'react';
import { FadeIn } from './FadeIn';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative pt-20 pb-12 px-4 md:px-6 overflow-hidden bg-tech-pattern" data-id="element-88">
      <div className="absolute inset-0 bg-gradient-to-b from-[#0a0e1a]/80 via-[#0a0e1a]/95 to-[#0a0e1a] pointer-events-none" data-id="element-89"></div>

      <div className="max-w-6xl mx-auto relative z-10 grid lg:grid-cols-2 gap-8 items-center" data-id="element-90">
        <FadeIn data-id="element-91">
          <div className="space-y-5 text-center lg:text-left" data-id="element-92">
            <div className="inline-block px-4 py-1.5 rounded-full border border-cyan-500/30 bg-cyan-500/10 text-cyan-400 text-sm font-semibold tracking-wider mb-2" data-id="element-93">
              NUEVO PROTOCOLO DE BIOHACKING
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight" data-id="element-94">
              Cómo Eliminar la Neblina Mental y Recuperar tu{' '}
              <span className="text-cyan-400 text-glow" data-id="element-95">Energía Total</span> en
              Solo 7 Días
            </h1>
            <p className="text-xl md:text-2xl text-slate-300 font-light leading-relaxed" data-id="element-96">
              Sin Suplementos Caros ni Dietas Imposibles.
            </p>
            <p className="text-lg text-slate-400" data-id="element-97">
              El manual de biohacking de guerrilla diseñado para profesionales
              agotados que necesitan volver a rendir al 100% hoy mismo.
            </p>

            <div className="pt-4 flex justify-center lg:justify-start" data-id="element-98">
              <CTAButton text="SÍ, QUIERO EL PROTOCOLO POR $6.99" data-id="element-99" />
            </div>
          </div>
        </FadeIn>

        <FadeIn delay={0.2} className="flex justify-center lg:justify-end" data-id="element-100">
          <div className="relative w-full max-w-md" data-id="element-101">
            <div className="absolute inset-0 bg-cyan-500/20 blur-[60px] rounded-full" data-id="element-102"></div>
            <img src="https://cdn.magicpatterns.com/uploads/5exoYmt9VozeqzVQchaov6/PORTADA.png" alt="El Interruptor de Energía Ebook Cover" className="relative z-10 w-full h-auto rounded-xl shadow-2xl border border-cyan-500/20 transform hover:scale-[1.02] transition-transform duration-500" data-id="element-103" />
          </div>
        </FadeIn>
      </div>
    </section>;
}